import React, { useEffect, useState } from "react";
import { ContentWrapper } from "../../utils/components";
import './market.css';
import {
    faTachometerAlt,
    faGasPump,
    faCogs,
    faCogs as faCyl,  // voor "Cilinders"
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link, useNavigate } from "react-router-dom";

const MarketPage = () => {
    const navigate = useNavigate();
    const [cars, setCars] = useState([]);
    const [footerHeight, setFooterHeight] = useState(0);

    useEffect(() => {
        const fetchVehicle = async () => {
            try {
                const res = await fetch(`https://www.autoservicethomas.be/api/market/`);

                if (!res.ok) {
                    throw new Error(`Fout bij laden voertuig: ${res.statusText}`);
                }

                const data = await res.json();
                setCars(data);
            } catch (err) {
                // eventueel foutafhandeling hier
            }
        };

        fetchVehicle();
    }, []);

    useEffect(() => {
        const updateFooterHeight = () => {
            const footer = document.getElementsByClassName('garage-footer')[0];
            const header = document.getElementsByClassName('sticky')[0];
            if (footer) {
                setFooterHeight(footer.offsetHeight + header.offsetHeight);
            }
        };

        updateFooterHeight();

        window.addEventListener('resize', updateFooterHeight);
        return () => window.removeEventListener('resize', updateFooterHeight);
    }, []);

    /*useEffect(() => {
        // Handle messages from iframe (e.g., height adjustments)
        window.addEventListener('message', function (event) {
            if (~event.origin.indexOf('https://traders.stocklistdealer.eu')) {
                if (event.data.messageName) {
                    switch (event.data.messageName) {
                        case "documentHeight":
                            // Controleer of de hoogte geldig is en groter dan 500
                            if (event.data.messageValue && parseInt(event.data.messageValue) > 500) {
                                var newHeight = parseInt(event.data.messageValue) + 50; // Voeg 50px toe
                                var iFrame = document.getElementById('stocklistdealer_iframe_1');
                                if (iFrame) {
                                    iFrame.style.height = `${newHeight}px`; // Zet de nieuwe hoogte van het iframe
                                    iFrame.scrollIntoView(); // Scroll naar de iframe als dat nodig is
                                }
                            }
                            break;
                        default:
                            break;
                    }
                }
            } else {
                return;
            }
        });

        // Maak de event listener opgeruimd bij unmounting
        return () => {
            window.removeEventListener('message', function (event) { });
        };
    }, []);*/


    const getShortFuel = (fuel) => {
        if (fuel === "Hybride - Elektrisch/Benzine" || fuel === "Hybride - Elektrisch/Diesel") {
            return "Hybride";
        }

        return fuel;
    }

    const CarCard = ({ car }) => {
        const onClickCard = () => {
            navigate(`/tweedehands/${car._id}`);
        }

        const formatPrice = (price) => `€ ${price.toLocaleString('nl-BE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
        const formatKm = (km) => `${km.toLocaleString('nl-BE')} km`;

        return (
            <div className="car-card" onClick={onClickCard}>
                {car?.status !== "Beschikbaar" && <div className="sold-ribbon">{car?.status}</div>}
                <img src={`https://autoservicethomas.be/uploads/vehicles/${car.photos[0]}`} alt={`${car.brand} ${car.model}`} className="car-image" />
                <div className="card-content">
                    <h2>{car.title}</h2>
                    <p className="version">{car.version}</p>
                    <hr className="about-break card-break" />
                    <div className="car-details">
                        <span><FontAwesomeIcon icon={faTachometerAlt} className="icon" /><span>{formatKm(car.mileage)}</span></span>
                        <span><FontAwesomeIcon icon={faCogs} className="icon" /><span>{car.transmission}</span></span>
                        <span><FontAwesomeIcon icon={faGasPump} className="icon" /><span>{getShortFuel(car.fuel)}</span></span>
                    </div>
                    <hr className="about-break card-break" />
                    <div className="price-details-row">
                        <p className="price">{formatPrice(car?.price)} <span style={{ fontWeight: 400, fontSize: "0.8rem" }}>{car?.vatIncluded ? "Incl. BTW" : "Excl. BTW"}</span></p>
                        <Link to={`/tweedehands/${car._id}`} className="details-link">Meer info →</Link>
                    </div>
                </div>
            </div>
        );
    };

    const CarList = () => {
        return (
            <div>
                <div className="car-list-container">
                    <h2 className="title results-counter">
                        {cars.length === 0
                            ? 'Eigen stock - Momenteel geen wagens in stock.'
                            : cars.length === 1
                                ? 'Eigen stock - 1 wagen in stock.'
                                : `Eigen stock - ${cars.length} wagens in stock.`}
                    </h2>
                    <div className="car-grid">
                        {cars.map((car) => (
                            <CarCard key={car._id} car={car} />
                        ))}
                    </div>
                </div>
                <hr className="about-break card-break" style={{ marginTop: 50 }} />
                <div className="car-list-container">
                    <h2 className="title results-counter">
                        Niet gevonden wat je zoekt?
                    </h2>
                    <p className="contact-text">Geen zorgen, we hebben nog veel meer voertuigen in ons aanbod! Dankzij onze samenwerking met <span style={{ fontWeight: 600 }}>Stocklistdealer</span> kunnen we snel de juiste wagen voor je vinden. Via hun uitgebreide netwerk hebben we toegang tot een breed scala aan voertuigen die wellicht perfect aansluiten bij jouw wensen en eisen.</p>
                    <a className="cta-button" style={{marginTop: 10}} target="_blank" href="https://traders.stocklistdealer.eu/website/eyJpdiI6IjZtYjZnSkE2OWtLdXp6VTVOYitmcGc9PSIsInZhbHVlIjoiMnJoQklLZG9jZ2JrQUFwL3p6bDFFQT09IiwibWFjIjoiYzRmNWFjMzBmZTJlMzljYzgwYjYyMmM2MGI0NjBjNTUzMmZjOGU4MTI0NWFlOWVmY2EyZjc5YWZhOWJkMjI4NyIsInRhZyI6IiJ9?lang=nl"
                    >
                        Bekijk alle voertuigen
                    </a>
                </div>
                {/*<hr className="about-break card-break" style={{ marginTop: 50 }} />
                <div className="car-list-container">
                    <h2 className="title results-counter">
                        Voertuigen aangeboden via Stocklistdealer
                    </h2>
                    <iframe name="InlineFrame1" id="stocklistdealer_iframe_1" src="https://traders.stocklistdealer.eu/website/eyJpdiI6IjZtYjZnSkE2OWtLdXp6VTVOYitmcGc9PSIsInZhbHVlIjoiMnJoQklLZG9jZ2JrQUFwL3p6bDFFQT09IiwibWFjIjoiYzRmNWFjMzBmZTJlMzljYzgwYjYyMmM2MGI0NjBjNTUzMmZjOGU4MTI0NWFlOWVmY2EyZjc5YWZhOWJkMjI4NyIsInRhZyI6IiJ9?lang=nl" scrolling="no" title="TWEEDEHANDS" allowFullScreen></iframe>
                </div>*/}
            </div>
        );
    };

    return (
        <section className="section market-section" style={{ minHeight: `calc(100vh - ${footerHeight}px)` }}>
            <ContentWrapper>
                <h2 className="title market-title">Onze tweedehandswagens</h2>
                <p className="contact-text">
                    <span style={{ fontWeight: 600 }}>Dankzij onze samenwerking met Auto-First bieden wij eveneens tweedehandswagens aan.</span> Mede door een uitgebreide voorraad kunnen we gericht op zoek gaan naar een wagen die perfect bij u past.
                    Zoekt u een tweedehandswagen, maar hebt u weinig tijd om zelf te zoeken? Laat het ons gerust weten. Samen bekijken we uw wensen en voorkeuren, zodat we een selectie kunnen maken die echt bij u past.
                    Beschikt u over een beperkt budget? Geen probleem. Ook dan zoeken we graag mee naar de juiste wagen die aan uw verwachtingen voldoet — betaalbaar en betrouwbaar.
                </p>
                <p className="contact-text"><span style={{ fontWeight: 600 }}>Momenteel geen wagens in stock?</span> Dankzij ons uitgebreid netwerk binnen de autosector kunnen wij snel en gericht op zoek gaan naar een wagen die perfect aansluit bij uw wensen. Uw ideale auto is vaak dichterbij dan u denkt.</p>
                <p className="contact-text"><span style={{ fontWeight: 600 }}>Wist u trouwens dat u bij ons ook terechtkunt voor leasing?</span> Particulieren kunnen bij ons een wagen leasen aan scherpe voorwaarden. Zo rijdt u zorgeloos rond in een betrouwbare auto, zonder ineens een groot bedrag te moeten investeren. We bekijken graag samen welke leasingformule het best bij uw situatie past.</p>
                <CarList />
            </ContentWrapper>
        </section>
    );
}

export default MarketPage;
